import Modal from '../common/Modal';
import Button from '../common/Button';
import styles from './AchPromotionModal.module.css';

/**
 * ACH Promotion Modal
 * Displays promotional offer for ACH payment method (first month free)
 */
const AchPromotionModal = ({
  isOpen,
  onClose,
  onAccept,
  savingsAmount,
  productName
}) => {
  const formattedSavings = savingsAmount?.toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2
  }) || '$0.00';

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Save on Your First Order!" size="medium">
      <div className={styles.content}>
        {/* Promo Icon */}
        <div className={styles.iconContainer}>
          <svg
            className={styles.promoIcon}
            width="64"
            height="64"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
          >
            <path d="M12 2v20M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" />
          </svg>
        </div>

        {/* Promo Message */}
        <div className={styles.messageContainer}>
          <h3 className={styles.headline}>Get Your First Month Free!</h3>
          <p className={styles.message}>
            Pay with ACH bank transfer and save <strong>{formattedSavings}</strong> on your first order
            {productName && <> of <strong>{productName}</strong></>}.
          </p>
        </div>

        {/* Benefits List */}
        <div className={styles.benefits}>
          <h4>Why ACH?</h4>
          <ul>
            <li>First month completely free</li>
            <li>Direct bank transfer — no card fees</li>
            <li>Secure, encrypted payments</li>
            <li>Easy recurring payments</li>
          </ul>
        </div>

        {/* Action Buttons */}
        <div className={styles.actions}>
          <Button onClick={onAccept} fullWidth>
            Yes, Use ACH & Save
          </Button>
          <Button onClick={onClose} variant="outline" fullWidth>
            No Thanks, Use Card
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default AchPromotionModal;
